<template>
<v-list-item @click='$emit("selected", address)' >
  <v-list-item-avatar :rounded='"0"' >
    <v-img v-if="thumbnail" :src='thumbnail' aspect-ratio="1:1" />
    <v-icon v-else >mdi-map-marker</v-icon>
  </v-list-item-avatar>
  <v-list-item-content>
    <v-list-item-title v-if='address.name' >
      {{address.name}}
      <small v-if='address.latitude && address.longitude' >
        {{ address.latitude.toString().substring(0, 6) }},{{ address.longitude.toString().substring(0, 6) }}
      </small>
      <v-chip x-small label
        v-if='address.is_virtual'
        color='info' class='ml-2' >Virtual</v-chip>
    </v-list-item-title>
    <v-list-item-title v-else >
      Click to edit
    </v-list-item-title>
    <v-list-item-subtitle v-if='address.name && !address.is_virtual' >
      {{address.address}}
    </v-list-item-subtitle>

    <v-list-item-subtitle
      v-if='!address.is_virtual && address.map_link' >
      <a :href="address.map_link" target="_blank" >{{ address.map_link }}</a>
    </v-list-item-subtitle>

    <v-list-item-subtitle
      v-if='address.is_virtual && address.url'
      v-text='address.url' />

  </v-list-item-content>
  <slot name='actions' >
  </slot>
  <v-list-item-action v-if='withEdit' class='mr-1' >
    <v-btn @click="$emit('hours', address)" small outlined >Hours</v-btn>
  </v-list-item-action>
  <v-list-item-action v-if='withEdit' >
    <v-btn @click="$emit('edit', address)" small outlined >Edit</v-btn>
  </v-list-item-action>
  <v-list-item-action v-if='withDelete' >
    <v-btn icon color='error' class='mt-3'
      @click="confirmDelete=true" small >
      <v-icon>mdi-delete</v-icon>
    </v-btn>
    <v-dialog v-model='confirmDelete' width='460' >
      <v-card>
        <v-card-title class='subtitle-1 overline' >
          Please confirm
        </v-card-title>
        <v-card-text>
          <blockquote class='blockquote pl-0' >
            Are you sure you want to delete the location:
            <strong v-text='address.name' />
          </blockquote>
          <v-alert type='warning'>
            This will delete the location and unset the location field on any related appointments
          </v-alert>
        </v-card-text>
        <v-card-actions >
          <v-btn @click='confirmDelete=false' text >Cancel</v-btn>
          <v-spacer />
          <v-btn @click="$emit('delete', address)" color='error' >
            Confirm Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item-action>
</v-list-item>
</template>
<script>
export default {
  name: 'AddressListItem',
  props: {
    item: { type: Object, required: true },
    withEdit: { type: Boolean, required: true },
    withDelete: { type: Boolean, required: true }
  },
  data () {
    return {
      confirmDelete: false
    }
  },
  computed: {
    address () {
      return this.item
    },
    thumbnail () {
      if (this.address && this.address.latitude && this.address.longitude) {
        let lat = this.address.latitude
        let lng = this.address.longitude
        return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=14&size=180x180&scale=2&markers=color:blue%7C${lat},${lng}&key=AIzaSyDBLqBJhup-u2afKcqqonWzGC-vv_7YpnY`
      } else {
        return null
      }
    }
  }
}
</script>
